import React from "react";

// May be converted to an object later, when I will need more parameters
// But for now string is enough
export const FormContext = React.createContext<string>("");
